import cardImg from "../../../../../Assets/Images/card-img.png";
const MatrixData = ({ stats }) => {
  return (
    <div className="user-data shadow card border-0 mx-2">
      <div className="row">
        <div className="col-4">
          <div className="card-text data-column">
            <div className="card-img img-size">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">
                {stats?.lastActiveUsersInThirtyDays}
              </p>
              <p className="text-para m-0">active users in past 30 days</p>
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="card-text data-column">
            <div className="card-img img-size">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">
                {stats?.lastActiveUsersInSixtyDays}
              </p>
              <p className="text-para m-0">active users in past 60 days</p>
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="card-text data-column">
            <div className="card-img img-size">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">
                {stats?.lastActiveUsersInNintyDays}
              </p>
              <p className="text-para m-0">active users in past 90 days</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatrixData;
